// i18n.jsx — Translations + simple useT hook
// Two languages: es (default), en

  const dict = {
    es: {
      // Nav
      "nav.lvl01": "INICIO",
      "nav.lvl02": "ESTUDIO",
      "nav.lvl03": "SERVICIOS",
      "nav.lvl04": "PORTAFOLIO",
      "nav.lvl05": "EQUIPO",
      "nav.lvl06": "TALLERES",
      "nav.lvl07": "TIENDA",
      "nav.lvl08": "BLOG",
      "nav.lvl09": "CONTACTO",
      "nav.cta": "HABLEMOS",
      // Page hero subtitles (small intro per page)
      "page.home.title": "Inicio",
      "page.studio.title": "El estudio",
      "page.studio.sub": "Sabiduría, código y mito. Conoce al equipo y nuestro manifiesto.",
      "page.services.title": "Servicios",
      "page.services.sub": "Seis power-ups del estudio — independientes o en combo.",
      "page.portfolio.title": "Portafolio",
      "page.portfolio.sub": "Cartuchos reales: videojuegos, web, multimedia, audiovisual.",
      "page.workshops.title": "Talleres",
      "page.workshops.sub": "Entrenamiento práctico. Proyectos reales al portafolio.",
      "page.shop.title": "Tienda",
      "page.shop.sub": "Assets, kits y mercancía digital — power-ups para tu setup.",
      "page.blog.title": "Blog",
      "page.blog.sub": "Bitácora del estudio: devlogs, ensayos y tutoriales.",
      "page.contact.title": "Contacto",
      "page.contact.sub": "Cuéntanos tu idea. Respondemos directo, sin intermediarios.",
      // Studio explorer (home page menu)
      "home.explore.tag": "▸ SELECT WORLD",
      "home.explore.title": "Explora el estudio",
      "home.explore.sub": "Cada sala del estudio en su propio nivel. Elige tu ruta.",
      "home.explore.studioCta": "ENTRAR",
      "home.featured.tag": "▸ NOW PLAYING",
      "home.featured.title": "En la consola hoy",
      "home.featured.viewAll": "VER TODO EL PORTAFOLIO",
      "home.cta.tag": "▸ PRESS START",
      "home.cta.title": "¿Listo para insertar moneda en tu próximo proyecto?",
      "home.cta.sub": "Conversemos. Videojuego, app, identidad o experiencia educativa — empezamos por una llamada honesta.",
      "home.cta.primary": "HABLEMOS",
      "home.cta.secondary": "VER PORTAFOLIO",
      // HUD
      "hud.active": "ESTUDIO ACTIVO",
      "hud.score": "SCORE",
      "hud.lives": "1UP",
      "hud.activeProjects": "PROYECTOS ACTIVOS",
      "hud.location": "CALI · CO",
      "hud.lvl": "LVL",
      "hud.ticker": "NUEVO LANZAMIENTO · UNITY 6 MULTIPLAYER · TALLER ABIERTO · UNREAL 5 BOOTCAMP · CLIENTES 14 · PROYECTOS 30+ · INSCRIPCIONES TALLER MARZO ABIERTAS · ",

      // Hero
      "hero.pressStart": "PRESS START · ESTUDIO ACTIVO",
      "hero.title1": "Diseñamos",
      "hero.title2": "videojuegos",
      "hero.title3": "y mundos",
      "hero.title4": "interactivos.",
      "hero.lead": "Ragross Studios es un estudio creativo-tecnológico que construye videojuegos, experiencias multimedia y sistemas visuales con identidad. Tecnología, mito y propósito cultural.",
      "hero.ctaPrimary": "VER PORTAFOLIO",
      "hero.ctaSecondary": "INICIAR PROYECTO",
      "hero.chip1": "UNITY · GAME DEV",
      "hero.chip2": "WEB · MULTIMEDIA",
      "hero.chip3": "BRAND · IDENTITY",
      "hero.chip4": "AUDIOVISUAL",
      "hero.insertCoin": "insertar moneda",
      "hero.stage": "STAGE 01-A",
      "hero.statFounded": "FUNDADO",
      "hero.statProjects": "PROYECTOS",
      "hero.statClients": "CLIENTES",

      // About
      "about.tag": "/ NIVEL 02 · NOSOTROS",
      "about.title1": "Sabiduría convertida",
      "about.title2": "en código.",
      "about.body": "El búho es nuestro emblema: conocimiento ancestral, mirada estratégica y energía protectora. Construimos videojuegos, experiencias multimedia y piezas audiovisuales con intención cultural, educativa o comercial. No vendemos plantillas — operamos como un laboratorio creativo-tecnológico.",
      "about.pillar1.h": "ARTE + CÓDIGO",
      "about.pillar1.b": "Diseño que piensa. Código con intención narrativa.",
      "about.pillar2.h": "JUEGO COMO LENGUAJE",
      "about.pillar2.b": "Mecánicas que enseñan. Estética que recuerda.",
      "about.pillar3.h": "IMPACTO LOCAL",
      "about.pillar3.b": "Tecnología que amplifica voces y territorios.",
      "about.pillar4.h": "CRITERIO HUMANO",
      "about.pillar4.b": "Respuesta directa, sin filtros de agencia.",
      "about.motto": "\"Diseño como lenguaje. Código como ritual. Visual como memoria.\"",
      "about.mottoAttr": "▸ MANIFIESTO · RAGROSS",
      "about.emblem": "EMBLEMA",
      "about.since": "EST. 2018",

      // Services
      "svc.tag": "/ NIVEL 03 · SERVICIOS",
      "svc.title1": "Power-ups del estudio.",
      "svc.title2": "Elige tu nivel.",
      "svc.lead": "Seis capacidades del estudio. Cada una se entrega como un proyecto autónomo o como un combo. Hablemos de qué necesita tu idea para volverse real.",
      "svc.available": "DISPONIBLE",
      "svc.more": "VER",
      "svc.s1.name": "Videojuegos",
      "svc.s1.role": "GAME DEV · UNITY · WebGL",
      "svc.s1.desc": "Diseñamos mundos jugables. Prototipos, mecánicas, IA básica de NPCs, loops de progresión y experiencias VR inmersivas.",
      "svc.s2.name": "Multimedia interactiva",
      "svc.s2.role": "APPS · INSTALACIONES · AR",
      "svc.s2.desc": "Piezas digitales híbridas: animación, audio, video, UI reactiva e interacción en tiempo real para arte, educación o marca.",
      "svc.s3.name": "Diseño web",
      "svc.s3.role": "FRONT-END · UI TÉCNICA",
      "svc.s3.desc": "Sitios con estética propia, responsive y pensados para comunicar identidad. Sin plantillas, sin formulaicos.",
      "svc.s4.name": "Identidad visual",
      "svc.s4.role": "BRANDING · SISTEMA GRÁFICO",
      "svc.s4.desc": "Construimos símbolos. Logo, paleta cromática, manual de marca, tono visual y piezas aplicadas en digital y físico.",
      "svc.s5.name": "Audiovisual & foto",
      "svc.s5.role": "PRODUCCIÓN · POSPRODUCCIÓN",
      "svc.s5.desc": "Video y fotografía con dirección estética clara. Edición que refuerza historia, carácter y propósito.",
      "svc.s6.name": "Formación",
      "svc.s6.role": "MENTORÍA · TALLERES",
      "svc.s6.desc": "Entrenamiento práctico en desarrollo de videojuegos, web creativa, storytelling visual y diseño interactivo.",

      // Portfolio
      "pf.tag": "/ NIVEL 04 · PORTAFOLIO",
      "pf.title1": "Selecciona tu",
      "pf.title2": "cartucho.",
      "pf.lead": "Videojuegos, plataformas web, multimedia interactiva, branding y producción audiovisual — proyectos reales construidos para educación, cultura y marca.",
      "pf.filterAll": "TODO",
      "pf.filterGame": "VIDEOJUEGOS",
      "pf.filterWeb": "WEB",
      "pf.filterAv": "AUDIOVISUAL",
      "pf.filterMm": "MULTIMEDIA",
      "pf.more": "CARGAR MÁS PROYECTOS",
      "pf.p1.role": "Videojuego promocional · turismo Pacífico colombiano",
      "pf.p2.role": "Juego educativo · alfabetización temprana",
      "pf.p3.role": "Plataforma institucional · presencia regional",
      "pf.p4.role": "Sitio corporativo · industria + diseño",
      "pf.p5.role": "Landing producto · educación animada",
      "pf.p6.role": "Producción audiovisual · campaña visual",
      "pf.p7.role": "Plataforma · app SaaS de datos",
      "pf.p8.role": "Plataforma multimedia · contenidos animados",

      // Team
      "team.tag": "/ NIVEL 05 · EQUIPO",
      "team.title1": "Los",
      "team.title2": "jugadores",
      "team.title3": "del estudio.",
      "team.lead": "Pequeño equipo multidisciplinario. Cada quien con su clase, su build y sus ataques especiales. Sin agencia de por medio, sin intermediarios.",
      "team.lvl": "LVL",
      "team.xp": "XP",
      "team.specials": "SPECIALS",

      // Stack / Arsenal (replaces Team on Studio page)
      "stk.tag": "/ NIVEL 05 · ARSENAL",
      "stk.title1": "El",
      "stk.title2": "loadout",
      "stk.title3": "del estudio.",
      "stk.lead": "Sin intermediarios ni mercenarios: somos un estudio pequeño que controla su propio stack de punta a punta. Estas son las herramientas con las que construimos cada mundo.",
      "stk.cat.engine": "MOTOR DE JUEGO",
      "stk.cat.web": "WEB · FRONT-END",
      "stk.cat.3d": "3D · ASSETS",
      "stk.cat.pixel": "PIXEL ART",
      "stk.cat.xr": "INMERSIVO · AR/VR",
      "stk.cat.ui": "DISEÑO · UI",
      "stk.cat.backend": "BACKEND · DATOS",
      "stk.cat.audio": "AUDIO · SFX",
      "stk.proc.tag": "▸ CÓMO SUBE DE NIVEL",
      "stk.proc.title": "Cómo sube de nivel un proyecto",
      "stk.proc.s1.t": "BRIEF",
      "stk.proc.s1.d": "Conversación honesta. Definimos idea, audiencia y alcance real.",
      "stk.proc.s2.t": "PROTOTIPO",
      "stk.proc.s2.d": "Construimos lo jugable primero. Probamos la mecánica, no el slide.",
      "stk.proc.s3.t": "BUILD",
      "stk.proc.s3.d": "Producción completa: arte, código, audio e identidad en paralelo.",
      "stk.proc.s4.t": "LAUNCH",
      "stk.proc.s4.d": "Entrega, despliegue y soporte. El cartucho entra al portafolio.",

      // Workshops
      "ws.tag": "/ NIVEL 06 · TALLERES",
      "ws.title1": "Modo",
      "ws.title2": "cooperativo.",
      "ws.title3": "Entrenamiento.",
      "ws.lead": "Talleres y bootcamps presenciales en Cali y online. Llevamos a otrxs jugadores al siguiente nivel — sin teoría inflada, con proyectos reales que entran al portafolio.",
      "ws.duration": "DURACIÓN",
      "ws.mode": "MODO",
      "ws.start": "INICIA",
      "ws.seats": "CUPOS",
      "ws.enroll": "INSCRIBIRSE",
      "ws.w1.title": "Unity 6 · Multiplayer",
      "ws.w1.sub": "Construye un coop shooter desde cero",
      "ws.w1.dur": "6 SEMANAS · 48 H",
      "ws.w1.mode": "HÍBRIDO",
      "ws.w1.start": "MAR 12",
      "ws.w2.title": "Game Design Bootcamp",
      "ws.w2.sub": "Diseño de mecánicas, loops y narrativa",
      "ws.w2.dur": "4 SEMANAS · 32 H",
      "ws.w2.mode": "ONLINE",
      "ws.w2.start": "ABR 02",
      "ws.w3.title": "Pixel Art para juegos",
      "ws.w3.sub": "Sprites, tilesets y animación 8-bit",
      "ws.w3.dur": "3 SEMANAS · 18 H",
      "ws.w3.mode": "PRESENCIAL · CALI",
      "ws.w3.start": "ABR 23",
      "ws.w4.title": "Web Creativa con React",
      "ws.w4.sub": "Sitios con identidad y animación real",
      "ws.w4.dur": "5 SEMANAS · 30 H",
      "ws.w4.mode": "ONLINE",
      "ws.w4.start": "MAY 07",
      "ws.full": "CUPOS LLENOS",
      "ws.open": "ABIERTO",
      "ws.soon": "PRONTO",

      // Shop
      "shop.tag": "/ NIVEL 07 · TIENDA",
      "shop.title1": "Mercancía digital.",
      "shop.title2": "Power-ups para tu setup.",
      "shop.lead": "Assets, sprites, kits de UI y plantillas hechas en casa por el estudio. Cargadas con identidad, listas para reskin.",
      "shop.add": "AÑADIR",
      "shop.added": "EN CARRITO",
      "shop.cart": "CARRITO",
      "shop.items": "ITEMS",
      "shop.checkout": "PROCEDER AL PAGO",
      "shop.empty": "Carrito vacío",
      "shop.i1": "Pack Sprites Búho · 32×32",
      "shop.i1d": "120 sprites · 4 paletas · PNG + Aseprite",
      "shop.i2": "Ragross Pixel UI Kit",
      "shop.i2d": "Componentes Figma + Tailwind · 8-bit",
      "shop.i3": "Tilesets · Mundo Pacífico",
      "shop.i3d": "Selva, mar, ciudad · 4 capas · 16×16",
      "shop.i4": "Sound Pack · CRT Arcade",
      "shop.i4d": "84 efectos · WAV · 8-bit y modernos",
      "shop.i5": "Curso Unity Multiplayer (off-line)",
      "shop.i5d": "12h video + repositorio + assets",
      "shop.i6": "Set Posters · Estudio",
      "shop.i6d": "3 láminas A3 · papel mate · físico",

      // Blog
      "blog.tag": "/ NIVEL 08 · BLOG",
      "blog.title1": "Bitácora",
      "blog.title2": "del estudio.",
      "blog.lead": "Noticias y análisis de la industria del videojuego y la multimedia en 2026 — desde los grandes lanzamientos hasta lo que significan para los estudios independientes.",
      "blog.read": "LEER",
      "blog.featured": "DESTACADO",
      "blog.b1.cat": "NOTICIA",
      "blog.b1.title": "GTA 6 confirma su lanzamiento en consolas para noviembre de 2026",
      "blog.b1.meta": "JUN 2026 · 7 MIN · REDACCIÓN",
      "blog.b2.cat": "EVENTO",
      "blog.b2.title": "Summer Game Fest 2026: vuelven los remakes de Resident Evil y el cierre de Final Fantasy VII",
      "blog.b2.meta": "JUN 2026 · 9 MIN · REDACCIÓN",
      "blog.b3.cat": "INDUSTRIA",
      "blog.b3.title": "El primer año completo de Switch 2 y la escasez de memoria que sacude el hardware",
      "blog.b3.meta": "JUN 2026 · 6 MIN · REDACCIÓN",
      "blog.b4.cat": "NOTICIA",
      "blog.b4.title": "Marvel's Wolverine encabeza el catálogo 2026 de PlayStation",
      "blog.b4.meta": "MAY 2026 · 5 MIN · REDACCIÓN",

      // Clients
      "cl.tag": "▸ HALL OF PLAYERS",
      "cl.title": "Marcas y aliados que han jugado con nosotros",
      "cl.sub": "14 CLIENTES · 30+ PROYECTOS",

      // Contact
      "ct.tag": "/ NIVEL 09 · CONTACTO",
      "ct.title1": "¿Tienes una idea?",
      "ct.title2": "Insertemos moneda.",
      "ct.lead": "Videojuego, app, instalación cultural, identidad o experiencia educativa — cada proyecto empieza con una conversación honesta. Respondemos directo, sin filtros de agencia.",
      "ct.email": "EMAIL",
      "ct.whatsapp": "WHATSAPP",
      "ct.location": "UBICACIÓN",
      "ct.locationVal": "Cali · Colombia · 760036",
      "ct.formTag": "▸ INSERT COIN",
      "ct.sent": "MENSAJE ENVIADO · RESPONDEMOS PRONTO",
      "ct.sending": "ENVIANDO...",
      "ct.error": "NO SE PUDO ENVIAR · INTENTA DE NUEVO",
      "ct.name": "NOMBRE",
      "ct.namePh": "Tu nombre",
      "ct.emailPh": "tu@email.com",
      "ct.type": "TIPO DE PROYECTO",
      "ct.budget": "PRESUPUESTO ESTIMADO (OPCIONAL)",
      "ct.budgetPh": "USD · COP · rango",
      "ct.msg": "CUÉNTANOS TU IDEA",
      "ct.msgPh": "Mecánica, audiencia, plataforma, fechas tentativas...",
      "ct.submit": "ENVIAR MENSAJE",
      "ct.legal": "respuesta humana en 24–48h",
      "ct.t1": "Videojuego",
      "ct.t2": "Diseño Web",
      "ct.t3": "Identidad Visual / Branding",
      "ct.t4": "Multimedia interactiva",
      "ct.t5": "Producción Audiovisual",
      "ct.t6": "Formación / Taller",
      "ct.t7": "Otro",

      // Footer
      "ft.tag": "SABIDURÍA · CÓDIGO · MITO",
      "ft.tagline": "Estudio creativo-tecnológico en Cali, Colombia. Construimos videojuegos, experiencias multimedia y sistemas visuales con identidad simbólica y técnica.",
      "ft.colStudio": "ESTUDIO",
      "ft.colSocial": "REDES",
      "ft.colContact": "CONTACTO",
      "ft.response": "respuesta 24–48h",
      "ft.rights": "© 2025 RAGROSS STUDIOS · TODOS LOS DERECHOS RESERVADOS",
      "ft.thanks": "gracias por jugar",

      // Tweaks
      "tw.title": "TWEAKS",
      "tw.lang": "IDIOMA",
      "tw.display": "TIPOGRAFÍA DISPLAY",
      "tw.anim": "ANIMACIONES",
      "tw.mode": "MODO",
      "tw.viewport": "VISTA",
      "tw.modeArcade": "ARCADE TOTAL",
      "tw.modePro": "ESTUDIO PRO",
      "tw.fontSpace": "SPACE GROTESK",
      "tw.fontPress": "PRESS START",
      "tw.vpDesktop": "DESKTOP",
      "tw.vpMobile": "MOBILE",
      "tw.on": "ON",
      "tw.off": "OFF",
      "tw.konami": "PROBÁ EL CÓDIGO KONAMI ↑↑↓↓←→←→BA",

      "konami.toast": "★ CHEAT CODE DESBLOQUEADO ★\nMODO TURBO ACTIVADO\n+99 LIVES",
    },
    en: {
      "nav.lvl01": "HOME",
      "nav.lvl02": "STUDIO",
      "nav.lvl03": "SERVICES",
      "nav.lvl04": "WORK",
      "nav.lvl05": "TEAM",
      "nav.lvl06": "WORKSHOPS",
      "nav.lvl07": "SHOP",
      "nav.lvl08": "BLOG",
      "nav.lvl09": "CONTACT",
      "nav.cta": "LET'S TALK",
      "page.home.title": "Home",
      "page.studio.title": "The studio",
      "page.studio.sub": "Wisdom, code and myth. Meet the team and our manifesto.",
      "page.services.title": "Services",
      "page.services.sub": "Six studio power-ups — standalone or in combo.",
      "page.portfolio.title": "Work",
      "page.portfolio.sub": "Real cartridges: videogames, web, multimedia, audiovisual.",
      "page.workshops.title": "Workshops",
      "page.workshops.sub": "Hands-on training. Real projects join your portfolio.",
      "page.shop.title": "Shop",
      "page.shop.sub": "Assets, kits and digital merch — power-ups for your setup.",
      "page.blog.title": "Blog",
      "page.blog.sub": "Studio logbook: devlogs, essays and tutorials.",
      "page.contact.title": "Contact",
      "page.contact.sub": "Tell us your idea. We answer direct, no middlemen.",
      "home.explore.tag": "▸ SELECT WORLD",
      "home.explore.title": "Explore the studio",
      "home.explore.sub": "Every room of the studio as its own level. Pick your route.",
      "home.explore.studioCta": "ENTER",
      "home.featured.tag": "▸ NOW PLAYING",
      "home.featured.title": "On the console today",
      "home.featured.viewAll": "VIEW THE FULL PORTFOLIO",
      "home.cta.tag": "▸ PRESS START",
      "home.cta.title": "Ready to insert coin on your next project?",
      "home.cta.sub": "Let's talk. Videogame, app, identity or educational experience — we start with an honest call.",
      "home.cta.primary": "LET'S TALK",
      "home.cta.secondary": "VIEW WORK",
      "hud.active": "STUDIO ONLINE",
      "hud.score": "SCORE",
      "hud.lives": "1UP",
      "hud.activeProjects": "ACTIVE PROJECTS",
      "hud.location": "CALI · CO",
      "hud.lvl": "LVL",
      "hud.ticker": "NEW DROP · UNITY 6 MULTIPLAYER · WORKSHOP OPEN · UNREAL 5 BOOTCAMP · 14 CLIENTS · 30+ PROJECTS · MARCH WORKSHOP ENROLLMENTS OPEN · ",

      "hero.pressStart": "PRESS START · STUDIO ONLINE",
      "hero.title1": "We design",
      "hero.title2": "videogames",
      "hero.title3": "and interactive",
      "hero.title4": "worlds.",
      "hero.lead": "Ragross Studios is a creative-tech studio building videogames, multimedia experiences and visual systems with identity. Technology, myth and cultural purpose.",
      "hero.ctaPrimary": "VIEW WORK",
      "hero.ctaSecondary": "START A PROJECT",
      "hero.chip1": "UNITY · GAME DEV",
      "hero.chip2": "WEB · MULTIMEDIA",
      "hero.chip3": "BRAND · IDENTITY",
      "hero.chip4": "AUDIOVISUAL",
      "hero.insertCoin": "insert coin",
      "hero.stage": "STAGE 01-A",
      "hero.statFounded": "FOUNDED",
      "hero.statProjects": "PROJECTS",
      "hero.statClients": "CLIENTS",

      "about.tag": "/ LEVEL 02 · ABOUT US",
      "about.title1": "Wisdom turned",
      "about.title2": "into code.",
      "about.body": "The owl is our emblem: ancestral knowledge, strategic gaze and protective energy. We build videogames, multimedia experiences and audiovisual work with cultural, educational or commercial intent. We don't sell templates — we run as a creative-tech lab.",
      "about.pillar1.h": "ART + CODE",
      "about.pillar1.b": "Design that thinks. Code with narrative intent.",
      "about.pillar2.h": "PLAY AS LANGUAGE",
      "about.pillar2.b": "Mechanics that teach. Aesthetics that stick.",
      "about.pillar3.h": "LOCAL IMPACT",
      "about.pillar3.b": "Tech that amplifies voices and territories.",
      "about.pillar4.h": "HUMAN JUDGEMENT",
      "about.pillar4.b": "Direct answers. No agency filters.",
      "about.motto": "\"Design as language. Code as ritual. Visual as memory.\"",
      "about.mottoAttr": "▸ MANIFESTO · RAGROSS",
      "about.emblem": "EMBLEM",
      "about.since": "EST. 2018",

      "svc.tag": "/ LEVEL 03 · SERVICES",
      "svc.title1": "Studio power-ups.",
      "svc.title2": "Pick your level.",
      "svc.lead": "Six studio capabilities. Each shipped as a standalone project or as a combo. Let's talk about what your idea needs to come to life.",
      "svc.available": "AVAILABLE",
      "svc.more": "VIEW",
      "svc.s1.name": "Videogames",
      "svc.s1.role": "GAME DEV · UNITY · WebGL",
      "svc.s1.desc": "We design playable worlds. Prototypes, mechanics, basic NPC AI, progression loops and immersive VR experiences.",
      "svc.s2.name": "Interactive multimedia",
      "svc.s2.role": "APPS · INSTALLATIONS · AR",
      "svc.s2.desc": "Hybrid digital pieces: animation, audio, video, reactive UI and real-time interaction for art, education or brand.",
      "svc.s3.name": "Web design",
      "svc.s3.role": "FRONT-END · TECHNICAL UI",
      "svc.s3.desc": "Sites with their own aesthetic, responsive and built to communicate identity. No templates, no boilerplate.",
      "svc.s4.name": "Visual identity",
      "svc.s4.role": "BRANDING · GRAPHIC SYSTEM",
      "svc.s4.desc": "We build symbols. Logo, color palette, brand manual, visual tone and applied pieces — digital and physical.",
      "svc.s5.name": "Audiovisual & photo",
      "svc.s5.role": "PRODUCTION · POST",
      "svc.s5.desc": "Video and photography with a clear aesthetic direction. Editing that reinforces story, character and purpose.",
      "svc.s6.name": "Training",
      "svc.s6.role": "MENTORSHIP · WORKSHOPS",
      "svc.s6.desc": "Hands-on training in game dev, creative web, visual storytelling and interactive design.",

      "pf.tag": "/ LEVEL 04 · WORK",
      "pf.title1": "Select your",
      "pf.title2": "cartridge.",
      "pf.lead": "Videogames, web platforms, interactive multimedia, branding and audiovisual production — real projects built for education, culture and brand.",
      "pf.filterAll": "ALL",
      "pf.filterGame": "VIDEOGAMES",
      "pf.filterWeb": "WEB",
      "pf.filterAv": "AUDIOVISUAL",
      "pf.filterMm": "MULTIMEDIA",
      "pf.more": "LOAD MORE PROJECTS",
      "pf.p1.role": "Promo videogame · Colombian Pacific tourism",
      "pf.p2.role": "Educational game · early literacy",
      "pf.p3.role": "Institutional platform · regional presence",
      "pf.p4.role": "Corporate site · industry + design",
      "pf.p5.role": "Product landing · animated education",
      "pf.p6.role": "Audiovisual production · visual campaign",
      "pf.p7.role": "Platform · data SaaS app",
      "pf.p8.role": "Multimedia platform · animated content",

      "team.tag": "/ LEVEL 05 · TEAM",
      "team.title1": "The",
      "team.title2": "players",
      "team.title3": "of the studio.",
      "team.lead": "Small multidisciplinary team. Each one with their class, their build and their special attacks. No agency between you and us.",
      "team.lvl": "LVL",
      "team.xp": "XP",
      "team.specials": "SPECIALS",

      "stk.tag": "/ LEVEL 05 · ARSENAL",
      "stk.title1": "The studio",
      "stk.title2": "loadout",
      "stk.title3": "",
      "stk.lead": "No middlemen, no mercenaries: we're a small studio that owns its stack end to end. These are the tools we build every world with.",
      "stk.cat.engine": "GAME ENGINE",
      "stk.cat.web": "WEB · FRONT-END",
      "stk.cat.3d": "3D · ASSETS",
      "stk.cat.pixel": "PIXEL ART",
      "stk.cat.xr": "IMMERSIVE · AR/VR",
      "stk.cat.ui": "DESIGN · UI",
      "stk.cat.backend": "BACKEND · DATA",
      "stk.cat.audio": "AUDIO · SFX",
      "stk.proc.tag": "▸ HOW A PROJECT LEVELS UP",
      "stk.proc.title": "How a project levels up",
      "stk.proc.s1.t": "BRIEF",
      "stk.proc.s1.d": "An honest conversation. We define the idea, audience and real scope.",
      "stk.proc.s2.t": "PROTOTYPE",
      "stk.proc.s2.d": "We build the playable part first. We test the mechanic, not the slide.",
      "stk.proc.s3.t": "BUILD",
      "stk.proc.s3.d": "Full production: art, code, audio and identity in parallel.",
      "stk.proc.s4.t": "LAUNCH",
      "stk.proc.s4.d": "Delivery, deployment and support. The cartridge joins the portfolio.",

      "ws.tag": "/ LEVEL 06 · WORKSHOPS",
      "ws.title1": "Co-op",
      "ws.title2": "mode.",
      "ws.title3": "Training.",
      "ws.lead": "In-person and online workshops & bootcamps in Cali. We take other players to the next level — no inflated theory, with real projects that join your portfolio.",
      "ws.duration": "DURATION",
      "ws.mode": "MODE",
      "ws.start": "STARTS",
      "ws.seats": "SEATS",
      "ws.enroll": "ENROLL",
      "ws.w1.title": "Unity 6 · Multiplayer",
      "ws.w1.sub": "Build a co-op shooter from scratch",
      "ws.w1.dur": "6 WEEKS · 48 H",
      "ws.w1.mode": "HYBRID",
      "ws.w1.start": "MAR 12",
      "ws.w2.title": "Game Design Bootcamp",
      "ws.w2.sub": "Mechanics, loops & narrative design",
      "ws.w2.dur": "4 WEEKS · 32 H",
      "ws.w2.mode": "ONLINE",
      "ws.w2.start": "APR 02",
      "ws.w3.title": "Pixel Art for games",
      "ws.w3.sub": "Sprites, tilesets and 8-bit animation",
      "ws.w3.dur": "3 WEEKS · 18 H",
      "ws.w3.mode": "ON-SITE · CALI",
      "ws.w3.start": "APR 23",
      "ws.w4.title": "Creative Web with React",
      "ws.w4.sub": "Sites with identity and real animation",
      "ws.w4.dur": "5 WEEKS · 30 H",
      "ws.w4.mode": "ONLINE",
      "ws.w4.start": "MAY 07",
      "ws.full": "SOLD OUT",
      "ws.open": "OPEN",
      "ws.soon": "SOON",

      "shop.tag": "/ LEVEL 07 · SHOP",
      "shop.title1": "Digital goods.",
      "shop.title2": "Power-ups for your setup.",
      "shop.lead": "Assets, sprites, UI kits and templates made in-house. Loaded with identity, ready to reskin.",
      "shop.add": "ADD",
      "shop.added": "IN CART",
      "shop.cart": "CART",
      "shop.items": "ITEMS",
      "shop.checkout": "CHECKOUT",
      "shop.empty": "Cart empty",
      "shop.i1": "Owl Sprite Pack · 32×32",
      "shop.i1d": "120 sprites · 4 palettes · PNG + Aseprite",
      "shop.i2": "Ragross Pixel UI Kit",
      "shop.i2d": "Figma + Tailwind components · 8-bit",
      "shop.i3": "Tilesets · Pacific World",
      "shop.i3d": "Jungle, sea, city · 4 layers · 16×16",
      "shop.i4": "Sound Pack · CRT Arcade",
      "shop.i4d": "84 SFX · WAV · 8-bit & modern",
      "shop.i5": "Unity Multiplayer Course (offline)",
      "shop.i5d": "12h video + repo + assets",
      "shop.i6": "Studio Poster Set",
      "shop.i6d": "3 A3 prints · matte paper · physical",

      "blog.tag": "/ LEVEL 08 · BLOG",
      "blog.title1": "Studio",
      "blog.title2": "logbook.",
      "blog.lead": "News and analysis on the videogame and multimedia industry in 2026 — from the biggest releases to what they mean for independent studios.",
      "blog.read": "READ",
      "blog.featured": "FEATURED",
      "blog.b1.cat": "NEWS",
      "blog.b1.title": "GTA 6 locks in a November 2026 console launch date",
      "blog.b1.meta": "JUN 2026 · 7 MIN · NEWSROOM",
      "blog.b2.cat": "EVENT",
      "blog.b2.title": "Summer Game Fest 2026: Resident Evil remakes and the end of Final Fantasy VII",
      "blog.b2.meta": "JUN 2026 · 9 MIN · NEWSROOM",
      "blog.b3.cat": "INDUSTRY",
      "blog.b3.title": "Switch 2's first full year and the memory shortage shaking up hardware",
      "blog.b3.meta": "JUN 2026 · 6 MIN · NEWSROOM",
      "blog.b4.cat": "NEWS",
      "blog.b4.title": "Marvel's Wolverine leads PlayStation's 2026 lineup",
      "blog.b4.meta": "MAY 2026 · 5 MIN · NEWSROOM",

      "cl.tag": "▸ HALL OF PLAYERS",
      "cl.title": "Brands and partners who've played with us",
      "cl.sub": "14 CLIENTS · 30+ PROJECTS",

      "ct.tag": "/ LEVEL 09 · CONTACT",
      "ct.title1": "Got an idea?",
      "ct.title2": "Let's insert coin.",
      "ct.lead": "Videogame, app, cultural installation, identity or educational experience — every project starts with an honest conversation. We answer direct, no agency filters.",
      "ct.email": "EMAIL",
      "ct.whatsapp": "WHATSAPP",
      "ct.location": "LOCATION",
      "ct.locationVal": "Cali · Colombia · 760036",
      "ct.formTag": "▸ INSERT COIN",
      "ct.sent": "MESSAGE SENT · WE'LL REPLY SOON",
      "ct.sending": "SENDING...",
      "ct.error": "COULD NOT SEND · TRY AGAIN",
      "ct.name": "NAME",
      "ct.namePh": "Your name",
      "ct.emailPh": "you@email.com",
      "ct.type": "PROJECT TYPE",
      "ct.budget": "ESTIMATED BUDGET (OPTIONAL)",
      "ct.budgetPh": "USD · COP · range",
      "ct.msg": "TELL US YOUR IDEA",
      "ct.msgPh": "Mechanics, audience, platform, tentative dates...",
      "ct.submit": "SEND MESSAGE",
      "ct.legal": "human reply in 24–48h",
      "ct.t1": "Videogame",
      "ct.t2": "Web Design",
      "ct.t3": "Visual Identity / Branding",
      "ct.t4": "Interactive Multimedia",
      "ct.t5": "Audiovisual Production",
      "ct.t6": "Training / Workshop",
      "ct.t7": "Other",

      "ft.tag": "WISDOM · CODE · MYTH",
      "ft.tagline": "Creative-tech studio in Cali, Colombia. We build videogames, multimedia experiences and visual systems with symbolic and technical identity.",
      "ft.colStudio": "STUDIO",
      "ft.colSocial": "SOCIAL",
      "ft.colContact": "CONTACT",
      "ft.response": "reply 24–48h",
      "ft.rights": "© 2025 RAGROSS STUDIOS · ALL RIGHTS RESERVED",
      "ft.thanks": "thanks for playing",

      "tw.title": "TWEAKS",
      "tw.lang": "LANGUAGE",
      "tw.display": "DISPLAY FONT",
      "tw.anim": "ANIMATIONS",
      "tw.mode": "MODE",
      "tw.viewport": "VIEWPORT",
      "tw.modeArcade": "FULL ARCADE",
      "tw.modePro": "STUDIO PRO",
      "tw.fontSpace": "SPACE GROTESK",
      "tw.fontPress": "PRESS START",
      "tw.vpDesktop": "DESKTOP",
      "tw.vpMobile": "MOBILE",
      "tw.on": "ON",
      "tw.off": "OFF",
      "tw.konami": "TRY THE KONAMI CODE ↑↑↓↓←→←→BA",

      "konami.toast": "★ CHEAT CODE UNLOCKED ★\nTURBO MODE ON\n+99 LIVES",
    }
  };

  function t(key, lang) {
    return (dict[lang] && dict[lang][key]) || (dict.es[key]) || key;
  }


export { dict, t };
